module.exports = __webpack_public_path__ + "img/crypto-dent-dent-red.02c0e52c.svg";